









































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { oneClickAlarmServer } from '@/api/installServer';
import publishObjectPath from '@/util/configRegistry';

@Component({
  components: {},
  mixins: [TableStripe],
  filters: {},
})
export default class DetailPage extends Vue {
  @Prop(String) rowId: any;
  private formData: any = {};

  fileList: any = [];
  headers: any = {};
  actionUrl: any = ''; // 图片上传
  private serverUrl = publishObjectPath.imgPathWater;

  handleForm: any = {
    handleOpinion: '',
    handleFileIds: '',
  };
  private loadingBtn: any = false;

  private handleSuccess(response: any, file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response.data) {
        arr.push(item.response.data[0].id);
      }
    });
    this.handleForm.handleFileIds = arr.toString(); // 存放选择的隐患图片
  }

  private handleRemove(file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response.data) {
        arr.push(item.response.data[0].id);
      }
    });
    this.handleForm.handleFileIds = arr.toString(); // 存放选择的隐患图片
  }
  // 图片预览
  previewList(imgData: any) {
    const arr: any = [];
    imgData.forEach((item: any) => {
      arr.push(`${this.serverUrl}${item.path}`);
    });
    return arr;
  }

  submitSave() {
    this.loadingBtn = true;
    oneClickAlarmServer
      .handleOneClickAlarm(this.rowId, {
        handleOpinion: this.handleForm.handleOpinion,
        handleFileIds: this.handleForm.handleFileIds,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.loadingBtn = false;
          this.$message.success('处置完成！');
          this.getDetail();
        } else {
          this.loadingBtn = false;
        }
      })
      .catch((error: any) => {
        this.loadingBtn = false;
      });
  }

  created() {
    this.getDetail();
  }
  mounted() {
    this.actionUrl = publishObjectPath.serverUrl + '/api/sysManage/sysFile';
    this.headers.Authorization = localStorage.getItem('token');
  }

  // 详情
  private getDetail() {
    oneClickAlarmServer.detailOneClickAlarm(this.rowId).then((res: any) => {
      if (res.code === '200') {
        this.formData = res.data;
      } else {
        this.$message.warning(res.msg);
      }
    });
  }

  private backClose() {
    this.$emit('closePage');
  }
}
